import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Route, Redirect } from "react-router-dom";
import NoDataFound from "./NoDataFound";

const ProtectedRoute = ({ component: Component, requiredRole, ...rest }) => {
  const isAuthenticated = !!localStorage.getItem("authToken"); // Check if user is authenticated

  const userRole = useSelector((state) => state.login);
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated) {
          return <Redirect to="/login" />; // Redirect to login page if not authenticated
        }

        const roleAllowed =
          userRole === null
            ? "user"
            : userRole.fld_usertype || (userRole?.fld_isadmin === 1 && "Staff");

        if (!requiredRole.includes(roleAllowed)) {
          return <Redirect to="/CustomError404" />; // Redirect to not found page if role does not match
        }

        return <Component {...props} />;
      }}
    />
  );
};

export default ProtectedRoute;

